import { MbscModule } from '@mobiscroll/angular';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { environment } from '../environments/environment';
import { FirestoreModule, getFirestore, provideFirestore } from '@angular/fire/firestore';
import { FirebaseAppModule, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';

import { NgbNavModule, NgbAccordionModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { COMPOSITION_BUFFER_MODE, FormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';
import { PushModalComponent } from './push-modal/push-modal.component';
import { UserModalComponent } from './user-modal/user-modal.component';
import { registerLocaleData } from '@angular/common';
import localeKo from '@angular/common/locales/ko';

registerLocaleData(localeKo, 'ko');
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  declarations: [AppComponent, PushModalComponent, UserModalComponent],
  imports: [
    MbscModule,
    FormsModule,

    NgChartsModule,
    FirebaseAppModule,
    FirestoreModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideAuth(() => getAuth()),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LayoutsModule,
    AppRoutingModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
  ],
  providers: [
    {
      provide: COMPOSITION_BUFFER_MODE,
      useValue: false,
    },
    {
      provide: COMPOSITION_BUFFER_MODE,
      useValue: false,
    },
    { provide: LOCALE_ID, useValue: 'ko-KR' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
